//import * as ACTIONS from '../../Redux.constants';
import {endTour} from './EndTour';
import {incrementTour} from './IncrementTour';
import {startTour} from './StartTour';

export function PageTourReducer(state, action) {
  switch (action.type) {
    case "PAGE TOUR/Start Tour":
      return startTour(state);
    case "PAGE TOUR/Increment Step":
      return incrementTour(state);
    case "PAGE TOUR/End Step":
      return endTour(state);
    default:
      return state;
  }
}
